import axios from 'axios';
var $http = axios.create({
    //@ts-ignore
    baseURL: process.env.API_BASE + 'api/'
});
export default {
    getContents({ state, commit }) {
        $http.get('contents').then(response => {
            commit('setPosts', response.data.posts);
            commit('setCategories', response.data.categories);
        });
    },
    getPost({ state, commit }, id) {
        $http.get('post', { params: { id: id } }).then(response => {
            commit('setCurrentPost', response.data);
        });
    },
    filterPosts({ state, commit }, cat) {
        commit('setCurrentCategory', cat);
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/store/actions.ts
// module id = null
// module chunks = 